import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getTranslationLanguageStats = api(async function getTranslationLanguageStats() {
    return query(
        gql`
            query GetTranslationLanguageStats {
                getTranslationLanguageStats {
                    code
                    name
                    nativeName
                    rtl
                    cachedSchedules
                    skillsTranslated
                }
            }
        `,
        {},
        { returns: "getTranslationLanguageStats" }
    )
})
